import { $t } from "@klondpay/locales";
const Layout = () => import("/@/layout/index.vue");

const institutionRouter = {
  path: "/insti",
  component: Layout,
  redirect: "/insti/admin",
  meta: {
    icon: "insti-admin",
    title: $t("menus.institution"),
    rank: 2,
    authority: ["acquirer.acquirer"]
  },
  children: [
    {
      path: "/insti/admin",
      name: "institutionTitle",
      component: () =>
        import("/@/views/institution-admin/InstitutionalAdmin/index.vue"),
      meta: {
        keepAlive: true,
        showParent: true,
        title: $t("institution.institutionTitle"),
        authority: ["acquirer.acquirer"]
      }
    },
    {
      path: "/insti/admin/detail",
      name: "institutionDetail",
      component: () =>
        import("/@/views/institution-admin/InstitutionalDetail/index.vue"),
      meta: {
        title: $t("institution.institutionDetail"),
        showLink: false,
        authority: ["acquirer.acquirer"],
        activeMenu: "/insti/admin"
      }
    },
    {
      path: "/insti/admin/add",
      name: "institutionAdd",
      component: () =>
        import("/@/views/institution-admin/InstitutionalAdd/index.vue"),
      meta: {
        title: $t("institution.institutionAdd"),
        showLink: false,
        authority: ["acquirer.acquirer"],
        activeMenu: "/insti/admin"
        // keepAlive: true
      }
    },
    {
      path: "/insti/admin/edit",
      name: "institutionEdit",
      component: () =>
        import("/@/views/institution-admin/InstitutionalAdd/index.vue"),
      meta: {
        title: $t("institution.institutionEdit"),
        showLink: false,
        authority: ["acquirer.acquirer"],
        activeMenu: "/insti/admin"
        // keepAlive: true
      }
    },
    {
      path: "/insti/info",
      name: "institutionInfo",
      component: () =>
        import("/@/views/institution-admin/InstitutionalInfo/index.vue"),
      meta: {
        title: $t("组织信息"),
        showLink: false,
        authority: ["acquirer.acquirer"],
        activeMenu: "/insti/admin"
      }
    }
  ]
};

export default institutionRouter;
